import { SET_PREVIEW_MEDIA } from './types';
const initialState = { media: [], current: -1 };
// eslint-disable-next-line import/prefer-default-export
export function previewMediaReducer(state = initialState, action) {
    switch (action.type) {
        case SET_PREVIEW_MEDIA:
            return Object.assign(Object.assign({}, state), action.payload);
        default:
            return state;
    }
}
